/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-arrow-down-right': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M6.25 16.25V15h7.869L3.75 4.631l.881-.881L15 14.119V6.25h1.25v10z"/>'
  }
})
